import { styled } from 'styled-components';

import { Theme } from '@/shared/themes';

export const Wrapper = styled.div`
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.background.contactUs};
  color: ${({ theme }: { theme: Theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 1.6rem 105px;
  border-top-left-radius: 64px;
  border-top-right-radius: 64px;

  & + footer {
    margin-top: -48px;
  }
`;
